/*
    Track:       z       y             h
    _____________|_______|_____________|
                  \-----/ \-----------/
                     |          |       
                     x          s

    z - our postition
    y - position where we should start breaking
    h - postion where we shou stop
*/

export const a = 2.5 // panels / s^2
const halfA = 1.25
export const t = 5 // seconds
export const v = t * a // panels / seconds
export const s = v * t - halfA * t * t

/*
animationTime           - miliseconds
startMovingTimestamp    - miliseconds
initialPosition         - integer
*/
export function getZ(animationTime: number, initialPosition: number) {
  // Place where we are in time
  const v = a * t // panels / s
  const moveBy = v * animationTime * 0.001
  const newPosition = initialPosition + moveBy

  return newPosition
}

/*
indexToStop             - place where we want to stop
animationTime           - miliseconds
startMovingTimestamp    - miliseconds
initialPosition         - integer
*/
export function getY(
  indexToStop: number,
  animationTime: number,
  startMovingTimestamp: number,
  initialPosition: number,
  breakingDistance: number,
  elementsLength: number
) {
  const currBlock = getZ(animationTime - startMovingTimestamp, initialPosition)

  if ((currBlock + breakingDistance) % elementsLength > indexToStop) {
    return Math.ceil((currBlock + breakingDistance) / elementsLength) * elementsLength + indexToStop - breakingDistance
  }

  return Math.floor((currBlock + breakingDistance) / elementsLength) * elementsLength + indexToStop - breakingDistance
}

// Get distance between current position and position where we will start breaking
/*
indexToStop             - place where we want to stop
animationTime           - miliseconds
startMovingTimestamp    - miliseconds
initialPosition         - integer
*/
export function getX(
  indexToStop: number,
  animationTime: number,
  startMovingTimestamp: number,
  initialPosition: number,
  elementsLength: number
) {
  const y = getY(indexToStop, animationTime, startMovingTimestamp, initialPosition, s, elementsLength)
  const z = getZ(animationTime - startMovingTimestamp, initialPosition)

  return y - z
}

export function getNextUniformRectilinearMotionValue(animationTime: number, initialPosition: number) {
  return getZ(animationTime, initialPosition)
}

export function getUniformRetardedMotionValue(animationTime: number, startBreakingTimestamp: number, z: number) {
  const passedBreakingTime = Math.min((animationTime - startBreakingTimestamp) * 0.001, t)
  let moveBy = v * passedBreakingTime - halfA * (passedBreakingTime * passedBreakingTime)

  return z + moveBy
}
